module.exports = __webpack_public_path__ + "static/media/stamp.0b457b07.png";